import { render, staticRenderFns } from "./inviter.vue?vue&type=template&id=506e1752&scoped=true&"
import script from "./inviter.vue?vue&type=script&lang=js&"
export * from "./inviter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e1752",
  null
  
)

export default component.exports